import React from 'react'
import { Link, RouteComponentProps } from 'react-router-dom'
import history from 'src/history'
import AppliedPromotion from './AppliedPromotion'
import { IAppliedPromotion } from '../../../../types'
import FormLabel from 'src/components/ui/form/FormLabel'
import { Button } from '@mobiscroll/react-latest'

interface IAppliedPromotions extends RouteComponentProps {
  userId: string
  appliedPromotions: IAppliedPromotion[]
  getAppliedPromotions: (userId: string) => void
  deleteAppliedPromotion: (promotionId: string, walletId: string, userId: string) => void
}

export default class AppliedPromotions extends React.Component<IAppliedPromotions> {
  public componentDidMount() {
    this.props.getAppliedPromotions(this.props.userId)
  }

  public render() {
    const handleRedirect = (path: string) => {
      history.push(path)
    }

    return (
      <div className='w100'>
        <div className='mt1'>
          <div className='mb2'>
            <div className='flex mb1 items-center justify-between'>
              <div className='font-grey2 bold h5'>Applied Promotions</div>
              <div>
                <Button
                  ariaLabel='applyPromotions'
                  className='mbsc-green-btn'
                  onClick={() => handleRedirect(`${this.props.match.path}/apply`)}
                >
                  Apply promotions
                </Button>
              </div>
            </div>
            <div className='w100 border-top pt2 flex items-center'>
              {this.props.appliedPromotions.map(appliedPromotion => (
                <AppliedPromotion
                  className='mr1 mb1 col-3'
                  {...appliedPromotion}
                  deleteAppliedPromotion={this.props.deleteAppliedPromotion}
                />
              ))}
              {this.props.appliedPromotions.length === 0 && (
                <div className='p3 flex items-center justify-center h5 font-grey2 border-light-grey4 rounded'>
                  No Existing Promotions
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/riders/riderdetails/promotions/AppliedPromotions.tsx